/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Redirect } from 'react-router-dom';

import { GroupThemedContentPanelWithFullHeader } from 'components/common/ContentPanel';
import Text from 'components/common/Text';
import Button from 'components/common/Button';

import navigationActions from 'redux/actions/navigation';

import sessionSelectors from 'redux/reduxStore/session';
import groupSelectors from 'redux/reduxStore/group';

import routeNames from 'lib/routeNames';
import { WhiteCardWithWidePadding } from 'components/common/Card/Card';
import { LocalText } from "../../common/LocalText";

function mapStateToProps(state) {
  const group = groupSelectors.getActiveGroup(state) || {};
  return {
    isLoggedIn: sessionSelectors.isLoggedIn(state),
    organizationName: group.organization_name || '',
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goBack: () => {
      dispatch(navigationActions.goBack(routeNames.home()));
    },
    goHome: () => {
      dispatch(navigationActions.goTo(routeNames.home()));
    },
  }
}

class ExpiredToken extends React.Component {

  constructor(props) {
    super(props);

    this.performResolveAction = this.performResolveAction.bind(this);

    this.state = {
      tryResolveAction: false,
    };
  }

  performResolveAction() {
    if (this.props.isLoggedIn) {
      this.props.goHome();
    } else {
      this.setState({ tryResolveAction: true });
    }
  }

  render() {
    const { message, resolutionMessage, resolveActionUrl, organizationName } = this.props;

    if (this.state.tryResolveAction) {
      return <Redirect to={resolveActionUrl} />;
    }

    return (
      <GroupThemedContentPanelWithFullHeader titlePhrase={{ id: 'tokenExpiry.title.text' }} subTitle={<LocalText text={organizationName}/>}>
        <WhiteCardWithWidePadding>
          <Text size="caption-1">
            <FormattedMessage id={message} />
          </Text>

          <section>
          <Text size="caption-1">
            <FormattedMessage id="tokenExpiry.resolution.message.text" />
          </Text>
          </section>

          <section>
          <Button
            className="theme-group base background"
            onClick={this.performResolveAction}
          >
            <FormattedMessage id={resolutionMessage} />
          </Button>
          </section>

          <Text size="footnote" colorName="middle-gray">
            <FormattedMessage id="checkInbox.spam.message.text" />
          </Text>
        </WhiteCardWithWidePadding>
      </GroupThemedContentPanelWithFullHeader>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExpiredToken);